import { render, staticRenderFns } from "./StakingInfo.vue?vue&type=template&id=87a7189a&"
import script from "./StakingInfo.vue?vue&type=script&lang=js&"
export * from "./StakingInfo.vue?vue&type=script&lang=js&"
import style0 from "./StakingInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports